const colors = {
  primary: {
    25: '#F5FAFF',
    50: '#EFF6FF',
    100: '#D1E3FF',
    200: '#B2D5FF',
    300: '#84BDFF',
    400: '#52A2FF',
    500: '#297FFF',
    600: '#156CEF',
    700: '#005EE0',
    800: '#004DC1',
    900: '#003879',
  },
  secondary: {
    50: '#F6FEFC',
    100: '#F0FDF9',
    200: '#CCFBEF',
    300: '#5FE9D0',
    400: '#2ED3B7',
    500: '#15B79E',
    600: '#0E9384',
    700: '#107569',
    800: '#125D56',
    900: '#134E48',
  },
  customGray: {
    25: '#FCFCFD',
    50: '#F9FAFB',
    100: '#F2F4F7',
    200: '#EAECF0',
    300: '#D0D5DD',
    400: '#98A2B3',
    500: '#667085',
    600: '#475467',
    700: '#344054',
    800: '#1D2939',
    900: '#101828',
  },
};

export default colors;
